import { walkTreeData } from 'he-tree-vue';

export function getDefaultStructure (digiBoards) {
    const defaultStructure = [{ text: 'All Boards', children: [] }];
    const allDigiBoards = digiBoards;
    const structure = defaultStructure;
    for (const digiboard of allDigiBoards) {
        structure[0].children.push({
            id: digiboard.external_id,
            text: `${digiboard.external_id} - ${digiboard.location}`,
        });
    }
    return structure;
};

export function addMissingBoards (treeData, digiBoards) {
    const availableBoards = [];
    walkTreeData(treeData, (node) => {
        if (node.id !== undefined) {
            availableBoards.push(node.id);
        }
    });
    const newBoards = digiBoards.filter(i => !availableBoards.includes(i.external_id));
    for (const newBoard of newBoards) {
        treeData[0].children.push({
            id: newBoard.external_id,
            text: `${newBoard.external_id} - ${newBoard.location}`,
        });
    }
    return treeData;
};
